<div class="game-history-specific-details col-12 col-md-8 pl-0">
    <!-- loader -->
    <div class="d-flex mt-2 game-history-specific-details__loader"
        *ngIf="!(!areDetailsLoaded && endDate); else gameHistorySpecificDetailsTemplate">
        <cv-loader [loaderType]="'cxone'" [size]="'medium'" [overlay]="false"></cv-loader>
    </div>
    <!-- main container -->
    <ng-template #gameHistorySpecificDetailsTemplate>
        <!-- title section -->
        <h3 class="game-history-specific-details__title">{{ titleSection }}</h3>

        <div class="game-history-specific-details__container d-flex"
            [class.game-history-specific-details__container--mm]="isMultiplierMadness"
            [class.game-history-specific-details__container--milestone]="isMilestone"
            *ngFor="let reward of gameRewards; let idx = index">
            <div class="game-history-specific-details__reward-container d-md-flex align-items-center pl-0"
                *ngIf="getGameRewardLabel(idx, reward) as rewardLabel"
                [ngClass]="{'col-7': hasExtraInfoGameType, 'col-4': !hasExtraInfoGameType}">
                <!-- reward label -->
                <div class="game-history-specific-details__reward-info d-flex align-items-center px-0">
                    <div class="d-flex align-items-center">
                        <div [ngClass]="rankIconClass" *ngIf="isRankTypeGame" class="d-flex">
                            <svg>
                                <use [attr.href]="getRankIcons()">
                                </use>
                            </svg>
                            <span class="game-history-specific-details__icon-rank-text">{{ idx + 1 }}</span>
                        </div>

                        <ng-container *ngIf="this.game?.GameType === 3">
                            <div class="game-history-specific-details__icon-bullseye" [attr.data-reward-index]="idx">
                                <div *ngFor="let ring of reward.bullseyeRings; let i = index"
                                    [id]="'icon-bullseye__ring-' + i" class="icon-bullseye__ring"
                                    [ngStyle]="getRingStyle(i, idx)" [style.width.px]="ring.size"
                                    [style.height.px]="ring.size"></div>
                            </div>
                        </ng-container>
                    </div>
                    <span [solTooltip]="rewardLabel" [overflowOnly]="true" placement="right-end" appendTo="body"
                        class="game-history-specific-details__reward-text custom-text-truncate" [ngClass]="{'max-width-150': hasExtraInfoGameType, 'max-width-icon-game-type': !hasExtraInfoGameType && hasIconGameType, 
                        'max-width-no-extra-no-icon': !hasExtraInfoGameType && !hasIconGameType}">{{ rewardLabel
                        }}</span>
                </div>
                <!-- extra info -->
                <div class="game-history-specific-details_extra-info d-flex align-items-center pr-0"
                    *ngIf="hasExtraInfoGameType && getRewardExtraInfo(reward.name) as extraInfo">
                    <span [solTooltip]="extraInfo" [overflowOnly]="true" placement="right-end" appendTo="body"
                        class="game-history-specific-details__extra-info-text custom-text-truncate">{{ extraInfo }}
                    </span>
                </div>
            </div>
            <!-- badge and coins -->
            <div class="game-history-specific-details__reward-icon d-flex align-items-center" *ngIf="reward"
                [ngClass]="{'col-4': hasExtraInfoGameType, 'col-6': !hasExtraInfoGameType}">
                <div class="game-history-specific-details__reward-icon-coin d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <svg style="width: 16px;height: 16px;max-width: 16px;min-width: 16px;">
                            <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin">
                            </use>
                        </svg>
                    </div>
                    <span [solTooltip]="reward?.coinText" [overflowOnly]="true" placement="right-end" appendTo="body"
                        class="game-history-specific-details__reward-icon-coin-text custom-text-truncate max-width-50">{{
                        reward?.coinText }}</span>
                </div>
                <div *ngIf="hasBadges"
                    class="game-history-specific-details__reward-icon-badge d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <svg style="width: 16px;height: 16px;max-width: 16px;min-width: 16px;">
                            <use href="../App_Themes/CXone/icons/gamification/reward-badge.svg#reward-badge">
                            </use>
                        </svg>
                    </div>
                    <span [solTooltip]="reward?.badgeText" [overflowOnly]="true" placement="right-end" appendTo="body"
                        class="game-history-specific-details__reward-icon-badge-text custom-text-truncate max-width-50">{{
                        reward?.badgeText }}</span>
                </div>
            </div>
        </div>
    </ng-template>
</div>